import axios from './axios'
import { TblParametriVitali  } from '@/../../EshJSLib/models/patient'

export async function fetchRilevazioni(id : number) {
    const response = await axios.get(`/api/rilevazioniPatient/${id}`);
    return response.data;
}

export async function deletePatient(id: number) {
   const response = await axios.delete(`/api/rilevazioni/${id}`);
    return response.data;
}

// export async function updateRilevazioni(params:TblParametriVitali) {
//     const response = await axios.put(`/api/rilevazioni/${params.id}`,params);
//     return response.data;
// }



